import React, { forwardRef } from "react";
import { SectionCard, fmtNum, C } from "../shared";

const RangeBar = ({ label, low, high, current }) => {
  const noData = low == null || high == null;
  const pct = (!noData && current != null)
    ? Math.max(0, Math.min(100, ((current - low) / (high - low)) * 100))
    : null;
  return (
    <div style={{ marginBottom: 18 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
        <span style={{ fontSize: 12.5, color: C.body, fontWeight: 600 }}>{label}</span>
        {noData
          ? <span style={{ fontSize: 11, color: C.faint }}>No data</span>
          : <div style={{ display: "flex", gap: 10, fontSize: 12 }}>
              <span style={{ color: C.red, fontWeight: 600 }}>L {fmtNum(low)}</span>
              <span style={{ color: C.border }}>|</span>
              <span style={{ color: C.green, fontWeight: 600 }}>H {fmtNum(high)}</span>
            </div>}
      </div>
      <div style={{ height: 6, background: "#0c1016", borderRadius: 6, position: "relative", border: `1px solid ${C.border}` }}>
        {!noData && (
          <div style={{ position: "absolute", inset: 0, height: "100%", borderRadius: 6,
            background: "linear-gradient(90deg,#ef4444 0%,#f0b15a 50%,#22c55e 100%)" }} />
        )}
        {pct !== null && (
          <div style={{ width: 13, height: 13, background: "#fff", borderRadius: "50%",
            position: "absolute", top: -4, border: "2px solid #0a0c10",
            boxShadow: "0 1px 4px rgba(0,0,0,.5)", left: `calc(${pct.toFixed(1)}% - 6.5px)` }} />
        )}
      </div>
    </div>
  );
};

const PerfTile = ({ label, value }) => {
  const isPos = value >= 0;
  return (
    <div className="tdash-perf">
      <div className="tdash-perf-label">{label}</div>
      {value === null || value === undefined
        ? <div style={{ fontSize: 14, color: C.faint }}>—</div>
        : <>
            <div className="tdash-perf-value" style={{ color: isPos ? C.green : C.red }}>
              {isPos ? "+" : ""}{fmtNum(value)}%
            </div>
            <div style={{ marginTop: 8, height: 3, background: "#1a2029", borderRadius: 3 }}>
              <div style={{ height: 3, borderRadius: 3, background: isPos ? C.green : C.red,
                width: `${Math.min(100, Math.abs(value) * 3)}%` }} />
            </div>
          </>}
    </div>
  );
};

const PerformanceSection = forwardRef(({ ranges, perf, lastPrice }, ref) => (
  <SectionCard ref={ref} id="performance" icon="performance" title="Performance & Price Range">
    <div className="tdash-g2">
      <div>
        <RangeBar label="Day Range" low={ranges.day?.low} high={ranges.day?.high} current={lastPrice} />
        <RangeBar label="6 Months" low={ranges.six_months?.low} high={ranges.six_months?.high} current={lastPrice} />
        <RangeBar label="52 Weeks" low={ranges.fifty_two_week?.low} high={ranges.fifty_two_week?.high} current={lastPrice} />
      </div>
      <div className="tdash-g4" style={{ alignContent: "start" }}>
        <PerfTile label="1 Month"  value={perf["1_month"]} />
        <PerfTile label="3 Months" value={perf["3_months"]} />
        <PerfTile label="6 Months" value={perf["6_months"]} />
        <PerfTile label="1 Year"   value={perf["1_year"]} />
      </div>
    </div>
  </SectionCard>
));

export default PerformanceSection;
